export default __webpack_public_path__ + "static/media/fb32f3ded468f448b954559b97ab43e8e2b6cba2109e5b0b57d63697935d9282.4ce84fe7.png";